export const hasLowercaseError = { hasLowercase: true };

export function hasLowercaseLetter(str: string) {
  return /[a-z]/.test(str);
}
